import React from 'react';
const testimonials = [{
  name: 'Sarah K.',
  city: 'Melbourne',
  role: 'Senior Instructor',
  initial: 'S',
  text: "I finally have my Sundays back. My classes are structured, my transitions are seamless, and my studio owner has noticed the difference in client retention. Best $29 I've ever spent.",
  bg: 'bg-primary/10',
  color: 'text-primary'
}, {
  name: 'David P.',
  city: 'Perth',
  role: 'Studio Owner',
  initial: 'D',
  text: 'The clinical protocols gave me the confidence to handle injury modifications without panicking mid-class. This is a must-have for every boutique studio instructor.',
  bg: 'bg-secondary/15',
  color: 'text-secondary'
}, {
  name: 'Emma R.',
  city: 'Sydney',
  role: 'Pilates Instructor — Matwork',
  initial: 'E',
  text: "I've been teaching for 8 years and this Vault has completely changed how I prep. The flow sequences are gold and my clients can't stop telling me how much better the classes feel.",
  bg: 'bg-accent-sage/15',
  color: 'text-accent-sage'
}, {
  name: 'Olivia M.',
  city: 'Brisbane',
  role: 'Reformer Specialist',
  initial: 'O',
  text: 'The pre-natal and seniors modules let me open two brand new weekly classes at my studio. I made my investment back ten times over in the first month. No-brainer.',
  bg: 'bg-primary/10',
  color: 'text-primary'
}, {
  name: 'Hannah J.',
  city: 'Adelaide',
  role: 'Freelance Instructor',
  initial: 'H',
  text: 'The quality is unreal. Clean technical diagrams, logical progressions and proper anatomy — feels like it was made by a peer, not a faceless company. Worth every cent.',
  bg: 'bg-secondary/15',
  color: 'text-secondary'
}, {
  name: 'Chloe W.',
  city: 'Gold Coast',
  role: 'Matwork & Small Props',
  initial: 'C',
  text: 'The playlists and achievement certificates are the small details that make a huge difference. My clients feel looked after, and that translates directly into retention.',
  bg: 'bg-accent-sage/15',
  color: 'text-accent-sage'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-alt py-20 px-4 relative overflow-hidden" data-id="element-220">
      <div className="absolute top-20 right-0 w-72 h-72 bg-primary/5 rounded-full blur-[80px] pointer-events-none" data-id="element-221"></div>
      <div className="absolute bottom-20 left-0 w-72 h-72 bg-secondary/5 rounded-full blur-[80px] pointer-events-none" data-id="element-222"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-223">
        <div className="text-center mb-12 sm:mb-16" data-id="element-224">
          <span className="inline-block bg-primary/10 text-primary text-xs sm:text-sm font-bold uppercase tracking-wider px-4 py-1.5 rounded-full border border-primary/20 mb-5" data-id="element-225">
            💬 Verified Reviews
          </span>
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main mb-4 tracking-tight" data-id="element-226">
            What Australian Instructors are saying
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-227">
            <span className="text-secondary text-lg sm:text-xl" data-id="element-228">
              ⭐⭐⭐⭐⭐
            </span>
            <span className="text-text-sec font-medium text-sm sm:text-base" data-id="element-229">
              4.9/5 from +800 reviews
            </span>
          </div>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-230">
            From Melbourne to Perth, hear from the professionals who've chosen
            The Pilates Pack.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-231">
          {testimonials.map((t, i) => <article key={i} className="bg-white rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col shadow-[0_4px_20px_rgba(201,137,155,0.06)] hover:-translate-y-1 hover:shadow-[0_8px_30px_rgba(201,137,155,0.12)] transition-all duration-300 relative" data-id="element-232">
              <div className="text-secondary text-base mb-3" data-id="element-233">⭐⭐⭐⭐⭐</div>

              <p className="text-text-main text-base leading-relaxed mb-6 flex-1 relative" data-id="element-234">
                <span className="text-primary/40 font-serif text-3xl absolute -top-2 -left-1 leading-none" data-id="element-235">
                  "
                </span>
                <span className="relative z-10 italic" data-id="element-236">{t.text}</span>
              </p>

              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-237">
                <div className={`w-11 h-11 rounded-full ${t.bg} ${t.color} flex items-center justify-center font-serif font-bold text-lg flex-shrink-0`} data-id="element-238">
                  {t.initial}
                </div>
                <div className="min-w-0" data-id="element-239">
                  <p className="text-text-main font-bold text-sm leading-tight truncate" data-id="element-240">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs flex items-center gap-1 mt-0.5" data-id="element-241">
                    <span className="text-primary" data-id="element-242">📍</span>
                    {t.city} · {t.role}
                  </p>
                </div>
                <span className="ml-auto text-check-green text-xs font-bold uppercase tracking-wider flex items-center gap-1 flex-shrink-0" title="Verified purchase" data-id="element-243">
                  <span className="w-1.5 h-1.5 rounded-full bg-check-green" data-id="element-244"></span>
                  <span className="hidden sm:inline" data-id="element-245">Verified</span>
                </span>
              </div>
            </article>)}
        </div>

        <p className="text-center text-text-sec text-sm mt-10 font-medium" data-id="element-246">
          🇦🇺 Instructors from across Australia · Reviews collected over the past
          6 months
        </p>
      </div>
    </section>;
}